module.exports = __webpack_public_path__ + "static/media/04.02887bc3.mp3";